var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-widget-settings"},[(_vm.localValue.vqb)?_c('VQBForm',{model:{value:(_vm.localValue.vqb),callback:function ($$v) {_vm.$set(_vm.localValue, "vqb", $$v)},expression:"localValue.vqb"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }